/*eslint-disable*/
import React, { useEffect, useState } from "react";
import db from "../../db"

// reactstrap components

// core components
import Events from "../../components/Portfolio/Index/Events"
import EventVideo from "../../components/Portfolio/Index/EventVideo"
import ColorNavbar from "../../components/Navbars/ColorNavbar";
import EventCarousel from "../../components/Portfolio/Index/EventCarousel"
import { Controller, Scene } from "react-scrollmagic"

import styled from 'styled-components';
import { Helmet } from "react-helmet"
import { LoadingScreen } from "../../components/MiscFunctions"

const SectionWipesStyled = styled.div`
  overflow: hidden;
  
  .panel {
    height: 100vh;
    width: 100vw;
  }
`;

function Index() {
  document.documentElement.classList.remove("nav-open");

  // EventCarousel
  const [carouselItems, setCarouselItems] = useState([])
  useEffect(() => db.EventCategories.listenAll(setCarouselItems), [])

  // Events
  const [events, setEvents] = useState([])
  useEffect(() => db.Events.listenAll(setEvents), [])

  const [placeholder, setPlaceholder] = useState()
  useEffect(() => db.Placeholders.listenOne(setPlaceholder, "portfolio_video"), [])

  return (
    <div>
      {/* Meta tags in head */}
      <Helmet>
        <title>Portfolio and Event Services - Smart Event and Production Qatar's Best Event Manager </title>
        <meta name="description" content="View the Portfolio of Smart Event and Production - Qatar's 
        best Event manager, best Event organizer, and best Event production. We offer services ranging from
        Wedding events, Birthday events, Sports events, Public Events, Conferences, Equipment rentals, and many more!"/>
        <meta name="robots" content="index, follow" />
        <meta name="og:title" content="Smart Event and Production - Qatar's Best Event Manager. View our Portfolio here!" />
        <meta name="og:description" content="Smart Event and Production offers services ranging from
        Wedding events, Birthday events, Sports events, Public Events, Conferences, Equipment Rentals and many more!
        View our Portolio here!" />
      </Helmet>

      {
        !carouselItems ||
          (carouselItems && carouselItems.length > 0) ||
          !events ||
          (events && events.length > 0) ||
          placeholder
          ?
          <>
            <ColorNavbar changing={false} />
            <SectionWipesStyled>
              {/* react scroll magic that allows the pages to go on top of each other*/}
              <Controller globalSceneOptions={{ triggerHook: 'onLeave' }}>
                <Scene pin >
                  <div className="panel">
                    <EventVideo placeholder={placeholder} />
                  </div>
                </Scene>
                <Scene pin>
                  <div className="panel" style={{ marginBottom: "50%" }}>
                    <EventCarousel carouselItems={carouselItems} events={events} />
                  </div>
                </Scene>
              </Controller>
            </SectionWipesStyled>
            <Events events={events} />
          </>
          :
          <LoadingScreen />
      }
    </div>
  );
}

export default Index;